import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE || 'https://api.binko.me/api';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('binko_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('binko_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  sendOTP: (phone) => api.post('/auth/send-otp', { phone }),
  verifyOTP: (phone, otp) => api.post('/auth/verify-otp', { phone, otp }),
};

export default api;

export const userAPI = {
  register: (data) => api.post('/auth/register', data),
  getProfile: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  updatePhoto: (data) => api.post('/auth/photo', data),
  deleteAccount: () => api.delete('/auth/account'),
};

export const venueAPI = {
  getHome: () => api.get('/venues/home'),
  checkin: (data) => api.post('/checkin', data),
};
